module.exports = __webpack_public_path__ + "static/img/z6.e4a5e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z6.png
// module id = gOio
// module chunks = 1